'use client';

import JournalMenu from "@/src/components/journal-site/_partials/header/journal-menu/journal-menu";
import BreadCrumbs from "@/src/components/journal-site/_partials/header/breadcrumbs/breadcrumbs";
import { Box } from "@mui/material";
import MenuItem from "@/src/_types/menu-item";
import { mapToMenuItems } from "@/src/utils/database-helpers/menu-helper";

const JournalSiteHeader = ({ journal, mainJournal, breadcrumbs }: {
    journal: any,
    mainJournal: any,
    breadcrumbs: any[],
}) => {
    const menuItems: MenuItem[] = journal.menu ? mapToMenuItems(journal.menu, journal) : [];
    const authorGuide: MenuItem = {
        icon: journal.options?.template_configs?.authors_guide?.guide?.icon,
        label: journal.options?.template_configs?.authors_guide?.guide?.label,
        link: `/${journal.journal_url ? `${journal.journal_url}/knowledgebase` : '#'}`,
    }

    const submission: MenuItem = {
        icon: 'fa-duotone fa-file-circle-info',
        label: 'Submit Manuscript',
        link: journal.slug ? journal.slug + '/en/user/login' : '#',
    }

    return (
        <Box
            sx={{
                // backgroundImage: `url(${LETTERS_BACKGROUND})`,
                width: '100%',
                borderBottom: '1px solid black',
                // backgroundColor: 'custom.backgroundJournalHeader',
                position: 'relative',
                overflow: 'visible',
            }}
        >
            <BreadCrumbs 
                breadcrumbs={breadcrumbs} 
                journal={mainJournal}
            />
            {
                !journal.is_main_site &&
                <JournalMenu
                    menuItems={menuItems}
                    authorGuide={authorGuide}
                    journalTitle={journal.title}
                    journalSubtitle={journal.meta_data?.subtitle ?? null}
                    submission={submission}
                />
            }
        </Box>
    )
}

export default JournalSiteHeader;
